var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exit-button"},[_c('v-btn',{attrs:{"dark":_vm.$vuetify.breakpoint.mdAndUp,"icon":_vm.$vuetify.breakpoint.smAndDown,"loading":_vm.loading,"app":"","text":""},on:{"click":_vm.onLogout}},[_c('v-icon',{attrs:{"size":"25"}},[_vm._v("mdi-power")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }